import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { getInclusionsViewableLuxPlusTier } from 'selectors/luxPlusSelectors'

interface Props {
  departure?: App.CruiseDepartureDetails
  luxPlusInclusionsByTier?: App.LuxPlusInclusionsByTier
  booking?: App.Cruises.CruiseBooking
}

export function useCruiseOfferInclusions({ departure, luxPlusInclusionsByTier, booking }: Props): {
  inclusionDetails?: App.Cruises.OfferInclusionDetails
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
} {
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const inclusionsViewableLuxPlusTier = useAppSelector(getInclusionsViewableLuxPlusTier)

  const inclusionsByTier = departure?.luxPlusInclusionsByTier || luxPlusInclusionsByTier
  const departureLuxPlusInclusions = inclusionsByTier?.[inclusionsViewableLuxPlusTier] || []

  const luxPlusInclusions = booking?.luxPlusInclusions || departureLuxPlusInclusions || []
  const standardInclusions = booking?.standardInclusions || departure?.standardInclusions || []

  return {
    inclusionDetails: departure?.inclusionDetails,
    luxPlusInclusions: luxPlusEnabled ? luxPlusInclusions : [],
    standardInclusions,
  }
}
